{
  "collectionLabel": "הצעות"
}
